import React, { useState } from 'react'
import { DataGrid } from '@mui/x-data-grid';
import { Stack } from '@mui/material/';
import { InputFile } from './InputFile';
import { Template } from './Template'
import { Form, Button, Col } from '@deere/ux.uxframe-react'
import { validateSupplierNumbersByChunk } from '../../services/external.service';
import { createEMAssignments, validateSupplierPart, validateDuplicates } from '../../utils/fileUtil'
import { SUPPLIER_NUMBER_EM_COLUMN, DEERE_PART_EM_COLUMN, TEMPLATE_COLUMNS, TEMPLATE_NON_DEERE_COLUMNS, TEMPLATE_NAME, NON_DEERE_SUPPLIER_EMAIL_COLUMN, NON_DEERE_COMPANY_EMAIL_COLUMN, NON_DEERE_SUPPLIER_NUMBER_COLUMN, NON_DEERE_SUPPLIER_NAME_COLUMN, NON_DEERE_PART_NUMBER_COLUMN, NON_DEERE_PART_DESCRIPTION_COLUMN } from '../../utils/surveyLiterals'
import { ERR_SUPPLIER_REQUIRED, ERR_COLUMNS_REQUIRED, ERR_IN_ROW, ERR_ROW_DUPLICATED, ERR_REMOVE_EMPTY_LINES, ERR_SUP_NUM_INVALID, ERR_ALL_SUP_INVALID } from "../../utils/errorLiterals";

export const ExtendedMineralCard = ({ loading, setLoading, setErrorMessage, setSuccessMessage, campaign, setValidated, setDisableSubmit, authState, setInputFile, userInfo }) => {
    const [data, setData] = useState([]);
    const [columns, setColumns] = useState([]);

    const validateSupplierNumbers = () => {
        setLoading(true);
        setSuccessMessage('');
        setErrorMessage('');

        if (!Array.isArray(data) || data.length <= 0) {
            setValidated(true);
            setDisableSubmit(true);
            setErrorMessage(ERR_SUPPLIER_REQUIRED);
            setLoading(false);
            return;
        }
        const colSupplier = campaign.isNonDeere ? columns.find(col => col.headerName === NON_DEERE_SUPPLIER_NUMBER_COLUMN) : columns.find(col => col.headerName === SUPPLIER_NUMBER_EM_COLUMN)
        const colDeerePart = campaign.isNonDeere ? columns.find(col => (col.headerName === NON_DEERE_PART_NUMBER_COLUMN)) : columns.find(col => col.headerName === DEERE_PART_EM_COLUMN)
        if (!Array.isArray(columns) || colSupplier === undefined || colDeerePart === undefined) {
            setValidated(true);
            setDisableSubmit(true);
            setErrorMessage(`${ERR_COLUMNS_REQUIRED} ${SUPPLIER_NUMBER_EM_COLUMN} and ${DEERE_PART_EM_COLUMN}.`);
            setLoading(false);
            return;
        }
        const duplicates = validateDuplicates(data,SUPPLIER_NUMBER_EM_COLUMN,DEERE_PART_EM_COLUMN)
        const colsToValidate = [SUPPLIER_NUMBER_EM_COLUMN,DEERE_PART_EM_COLUMN];
        const nonDeereColsToValidate = [NON_DEERE_SUPPLIER_EMAIL_COLUMN, NON_DEERE_COMPANY_EMAIL_COLUMN, NON_DEERE_SUPPLIER_NUMBER_COLUMN, NON_DEERE_SUPPLIER_NAME_COLUMN, NON_DEERE_PART_NUMBER_COLUMN, NON_DEERE_PART_DESCRIPTION_COLUMN];

        const validSupplierPart = validateSupplierPart(data, campaign.isNonDeere ? nonDeereColsToValidate : colsToValidate);
        if (validSupplierPart.length > 0) {
            setValidated(true);
            setDisableSubmit(true);
            setErrorMessage(`${ERR_IN_ROW} : ${validSupplierPart.map(element => element)}`);
            setLoading(false);
            return;
        }
        if (duplicates.length > 0) {
            setValidated(true);
            setDisableSubmit(true);
            setErrorMessage(`${ERR_ROW_DUPLICATED} : ${duplicates.map(element => element)}`);
            setLoading(false);
            return;
        }
        const suppliers = data.map(element => element[SUPPLIER_NUMBER_EM_COLUMN]);
        if (Array.isArray(suppliers) && suppliers.length > 0) {
            const uniqueSuppliers = Array.from(new Set(suppliers));
            const formattedSuppliers = uniqueSuppliers.map(s => { return s !== null && s !== undefined ? s.toString().trim().padStart(10, '0') : "" })
            validateSupplierNumbersByChunk(authState.accessToken.accessToken, formattedSuppliers).then(sup => {
                if (sup && sup.length > 0) {
                    setValidated(true);
                    setDisableSubmit(true);
                    let errMsg = sup[0].length > 0 ? sup[0].join(', ') : sup[0]
                    if (errMsg === ', ' || errMsg.length === 0) {
                        setErrorMessage(ERR_REMOVE_EMPTY_LINES)
                    } else {
                        setErrorMessage(`${ERR_SUP_NUM_INVALID}: ${errMsg}`)
                    }
                } else {
                    setValidated(false);
                    setDisableSubmit(false);
                    campaign.assignments = createEMAssignments(data, userInfo)
                    setSuccessMessage(ERR_ALL_SUP_INVALID);
                }
                setLoading(false);
            });
        }
    }

    return (
        <>
            <Form.Row>
                <Form.Group as={Col} className="align-right">
                    <Form.Label className="uxf-label">Add EMRT File (latest unlocked version of EMRT)</Form.Label>
                    <Form.Control type="file" id="emrt-template" onChange={(event) => { setInputFile(event.target.files) }} disabled={loading} />
                </Form.Group>
            </Form.Row>
            <Form.Row>
                <Form.Group as={Col}>
                    <Form.Row>
                        <Form.Group as={Col}>
                            <Form.Label className="uxf-label">Supplier - Part</Form.Label>
                            <Stack direction="row" spacing={1} sx={{ mb: 1 }}>
                                <InputFile setData={setData} setColDefs={setColumns} loading={loading} />
                            </Stack>
                        </Form.Group>
                        <Form.Group as={Col}>
                            <Form.Label className="uxf-label">Supplier Part Template</Form.Label>
                            <Form.Row>
                                <Template csvData={campaign.isNonDeere ? TEMPLATE_NON_DEERE_COLUMNS : TEMPLATE_COLUMNS} fileName={TEMPLATE_NAME} />
                            </Form.Row>
                        </Form.Group>
                    </Form.Row>
                    <Form.Row>
                        <DataGrid autoHeight={true} rows={data} columns={columns} disableColumnMenu={true} rowsPerPageOptions={[]} pageSize={10} />
                    </Form.Row>
                </Form.Group>
            </Form.Row>
            <Form.Row className="d-block mb-4">
                <Form.Group as={Col} className="align-right" >
                    <Button variant="secondary" className="float-right" onClick={validateSupplierNumbers} disabled={loading}>
                        Validate Supplier Numbers
                    </Button>
                </Form.Group>
            </Form.Row>
        </>
    )
}
